import Vue from 'vue';

export const types = {
    REGISTER_DROPDOWN: 'REGISTER_DROPDOWN',
    UNREGISTER_DROPDOWN: 'UNREGISTER_DROPDOWN',
    TOGGLE_DROPDOWN: 'TOGGLE_DROPDOWN',
    CLOSE_DROPDOWN: 'CLOSE_DROPDOWN',
};


// Initial State
const state = {
    dropdowns: {},
};

// Getters
const getters = {
    dropdowns: state => state.dropdowns,
};

// Actions
const actions = {
    register: ({ commit }, name) => commit(types.REGISTER_DROPDOWN, name),
    toggle: ({ commit }, name) => commit(types.TOGGLE_DROPDOWN, name),
    unregister: ({ commit }, name) => commit(types.UNREGISTER_DROPDOWN, name),
    close: ({ commit }, name) => commit(types.CLOSE_DROPDOWN, name),
};


// Mutations
const mutations = {
    [types.REGISTER_DROPDOWN](state, name) {
        Vue.set(state.dropdowns, name, false);
    },
    [types.UNREGISTER_DROPDOWN](state, name) {
        delete state.dropdowns[name];
    },
    [types.TOGGLE_DROPDOWN](state, name) {
        state.dropdowns[name] = !state.dropdowns[name];
    },
    [types.CLOSE_DROPDOWN](state, name) {
        state.dropdowns[name] = false;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/dropdown.js